export default __webpack_public_path__ + "static/media/logo-icon.00a386d1.svg";